import { getAuth } from "firebase/auth";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAt,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetDealsByStatus = async (
  status = "*",
  Type = "*",
  SkipCount = 0,
  LimitCount = 5,
  Duration = "all"
) => {
  if (status === "*") return;

  try {
    /* Date */
    let TargetDate;

    let firstDocSnapshot = await getFirstDocSnapshot(
      status,
      Type,
      SkipCount,
      TargetDate
    );
    if (firstDocSnapshot === undefined) return [];
    const { uid } = getAuth().currentUser;

    const dealsCollection = collection(db, "deals");
    let q;

    if (
      Type === "*" &&
      (getLocalStorageItem("permissions")?.other_properties_permission ||
        getLocalStorageItem("role") === "admin")
    ) {
      q = query(
        dealsCollection,
        where("currentstatus", "==", status),
        where("bid", "==", getLocalStorageItem("bid")),

        limit(LimitCount),
        orderBy("createdAt", "desc"),
        startAt(firstDocSnapshot)
      );
    } else if (
      Type === "*" &&
      !getLocalStorageItem("permissions")?.other_properties_permission
    ) {
      q = query(
        dealsCollection,
        where("currentstatus", "==", status),
        where("bid", "==", getLocalStorageItem("bid")),
        where("createdBy", "==", uid),

        limit(LimitCount),
        orderBy("createdAt", "desc"),
        startAt(firstDocSnapshot)
      );
    } else {
      if (
        getLocalStorageItem("permissions")?.other_properties_permission ||
        getLocalStorageItem("role") === "admin"
      )
        q = query(
          dealsCollection,
          where("currentstatus", "==", status),
          where("bid", "==", getLocalStorageItem("bid")),
          where("interest", "==", Type),

          limit(LimitCount),
          orderBy("createdAt", "desc"),
          startAt(firstDocSnapshot)
        );
      else if (!getLocalStorageItem("permissions")?.other_properties_permission)
        q = query(
          dealsCollection,
          where("currentstatus", "==", status),
          where("bid", "==", getLocalStorageItem("bid")),
          where("createdBy", "==", uid),
          where("interest", "==", Type),

          limit(LimitCount),
          orderBy("createdAt", "desc"),
          startAt(firstDocSnapshot)
        );
    }
    const dealsSnapshot = await getDocs(q);
    const deals = [];

    dealsSnapshot.forEach((deal) =>
      deals.push({ id: deal.id, ...deal.data() })
    );
    console.log("Landbook App: Deals: ", deals);

    return deals;
  } catch (error) {
    console.log("Landbook App: Deals Error : ", error);
  }
};

const getFirstDocSnapshot = async (status, Type, SkipCount, TargetDate) => {
  try {
    const dealsCollection = collection(db, "deals");
    let q;
    const { uid } = getAuth().currentUser;

    if (
      Type === "*" &&
      (getLocalStorageItem("permissions")?.other_properties_permission ||
        getLocalStorageItem("role") === "admin")
    ) {
      q = query(
        dealsCollection,
        where("currentstatus", "==", status),
        where("bid", "==", getLocalStorageItem("bid")),
        limit(SkipCount + 1),
        orderBy("createdAt", "desc")
      );
    } else if (
      Type === "*" &&
      !getLocalStorageItem("permissions")?.other_properties_permission
    ) {
      q = query(
        dealsCollection,
        where("currentstatus", "==", status),
        where("bid", "==", getLocalStorageItem("bid")),
        where("createdBy", "==", uid),
        limit(SkipCount + 1),
        orderBy("createdAt", "desc")
      );
    } else {
      if (
        getLocalStorageItem("permissions")?.other_properties_permission ||
        getLocalStorageItem("role") === "admin"
      )
        q = query(
          dealsCollection,
          where("currentstatus", "==", status),
          where("bid", "==", getLocalStorageItem("bid")),
          where("interest", "==", Type),
          limit(SkipCount + 1),
          orderBy("createdAt", "desc")
        );
      else if (
        !getLocalStorageItem("permissions")?.other_properties_permission
      ) {
        q = query(
          dealsCollection,
          where("currentstatus", "==", status),
          where("bid", "==", getLocalStorageItem("bid")),
          where("createdBy", "==", uid),
          where("interest", "==", Type),
          limit(SkipCount + 1),
          orderBy("createdAt", "desc")
        );
      }
    }
    const dealsSnapshot = await getDocs(q);
    console.log("Landbook App: Deals: ", dealsSnapshot.docs[0]);

    return dealsSnapshot.docs.pop();
  } catch (error) {
    console.log("Landbook App: Deals Error : ", error);
  }
};

export default GetDealsByStatus;
